/* eslint-disable no-unused-vars */
import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Box,
	Button,
	Card,
	CardContent,
	FormControl,
	InputLabel,
	IconButton,
	MenuItem,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	useMediaQuery,
	FormControlLabel,
	Link,
	Checkbox,
	Typography,
	CircularProgress,
	Alert,
	Chip,
	Tooltip,
	Divider,
	Autocomplete,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useCart } from "../../context/cartContext";
import { useSite } from "../../context/siteContext";
import { useAuth } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DefaultLoader from "../../components/DefaultLoader/DefaultLoader";
import ScheduleOrder from "../../components/ScheduleOrder/ScheduleOrder";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import ComplianceDescriptionModal from "../../components/CompliancePolicy/ComplianceDescriptionModal";
import EulaLibraryModal from "../../components/CompliancePolicy/EulaLibraryModal";
import { openComplianceDocument } from "../../components/CompliancePolicy/complianceUtils";
import { ALERT_MESSAGES, BUTTON, LABELS, MENU_ITEMS, PLACEHOLDER, TABLE_HEADERS, TITLES, UI_TEXT } from "../../constants";
import { Check, Delete, Lan, ScheduleOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { getCustomerByIdForCusSites } from "../../services/scheduleOrderService";
import { getProductsById } from "../../services/cartService";
import { createOrder, getOrderStatusByRequestId } from "../../services/checkoutService";
import NotAuthorized from "../../components/NotAuthorized/NotAuthorized";
import { useOptions } from "../../context/optionContext";
import { useCompliance } from "../../context/complianceContext";
import DocCardImage from "../../components/DocCardImage/DocCardImage";
import OrderFailure from "../OrderFaliure/OrderFaliure";
import { getSiteAddressesNew, createSiteAddress, updateSiteAddress } from "../../services/manageSitesService";
import { toast } from "../../context/ToastContext";
import { useNotifications } from "../../context/NotificationContext";
import { DEFAULT_LAYOUT } from "../../config";
import { trackEvent } from "../../utilities/analyticsService";

// Delivery Terms by Legal Entity
const buildDT_BY_LE = (t) => ({
	AUSA: [
		{ term: "PPD-ADD", description: t("UI_TEXT.PREPAID_AND_ADD") },
		{ term: "COD", description: t("UI_TEXT.COLLECT_ON_DELIVERY") },
	],
	ACAN: [
		{ term: "PPD-ADD", description: t("UI_TEXT.PREPAID_AND_ADD") },
		{ term: "COD", description: t("UI_TEXT.COLLECT_ON_DELIVERY") },
	],
	EUUK: [
		{ term: "EXW", description: t("SHIPPING.EX_WORKS") },
		{ term: "DAP", description: t("SHIPPING.DELIVERY_AT_PLACE") },
		{ term: "DDP", description: t("SHIPPING.DELIVERY_DUTY_PAID") },
	],
});

const buildDM_BY_LE = (t) => ({
	AUSA: [
		{ code: "UPS-GND", description: t("UI_TEXT.UPS_GROUND") },
		{ code: "UPS-1DA", description: t("UI_TEXT.UPS_NEXT_DAY_AIR") },
		{ code: "UPS-1DM", description: t("SHIPPING.UPS_NEXT_DAY_AIR_AM_DELIVERY") },
		{ code: "UPS-2DA", description: t("SHIPPING.UPS_SECOND_DAY_AIR") },
		{ code: "FedEx-FG", description: t("UI_TEXT.FEDEX_GROUND") },
		{ code: "FedEx-F2", description: t("SHIPPING.FEDEX_SECOND_DAY_AIR") },
		{ code: "Speci-Spec", description: t("UI_TEXT.SPECIAL_INSTRUCTIONS") },
	],
	ACAN: [
		{ code: "UPS-GND", description: t("UI_TEXT.UPS_GROUND") },
		{ code: "UPS-1DA", description: t("UI_TEXT.UPS_NEXT_DAY_AIR") },
		{ code: "UPS-1DM", description: t("SHIPPING.UPS_NEXT_DAY_AIR_AM_DELIVERY") },
		{ code: "UPS-2DA", description: t("SHIPPING.UPS_SECOND_DAY_AIR") },
		{ code: "FedEx-FG", description: t("UI_TEXT.FEDEX_GROUND") },
		{ code: "FedEx-F2", description: t("SHIPPING.FEDEX_SECOND_DAY_AIR") },
		{ code: "Speci-Spec", description: t("UI_TEXT.SPECIAL_INSTRUCTIONS") },
	],
	EUUK: [
		{ code: "UPS-1DA", description: t("UI_TEXT.UPS_NEXT_DAY_AIR") },
		{ code: "UPS-1DM", description: t("SHIPPING.UPS_NEXT_DAY_AIR_AM_DELIVERY") },
		{ code: "UPS-2DA", description: t("SHIPPING.UPS_SECOND_DAY_AIR") },
		{ code: "FedEx-FG", description: t("UI_TEXT.FEDEX_GROUND") },
		{ code: "FedEx-F2", description: t("SHIPPING.FEDEX_SECOND_DAY_AIR") },
		{ code: "Speci-Spec", description: t("UI_TEXT.SPECIAL_INSTRUCTIONS") },
	],
});

const normalizeId = (value) => {
	if (value === undefined || value === null) return "";
	const normalized = String(value).trim();
	return normalized || "";
};
const getCartProductId = (item = {}) => item?.ProductID ?? item?.product_id ?? item?.productId ?? null;
const toNullableNumber = (value) => {
	const normalized = Number(value);
	return Number.isFinite(normalized) && normalized > 0 ? normalized : null;
};
const getCartMachineId = (item = {}) =>
	toNullableNumber(item?.machine_id ?? item?.machineId ?? item?.Product?.machine_id);
const getCartSiteLineId = (item = {}) =>
	toNullableNumber(item?.site_line_id ?? item?.siteLineId ?? item?.Product?.site_line_id);
const getCartLineName = (item = {}) =>
	item?.line_name || item?.lineName || item?.Product?.line_name || "";
const getCartLineNumber = (item = {}) =>
	item?.line_number || item?.lineNumber || item?.Product?.line_number || "";
const getScopeKey = (item = {}) => {
	const siteId = normalizeId(item?.site_id ?? item?.siteId);
	const cusId = normalizeId(item?.cus_id ?? item?.customer_id ?? item?.customerId);
	return siteId && cusId ? `${siteId}:${cusId}` : "";
};

const sameAsSelectedSite = (itemSite, selectedSite) =>
	normalizeId(itemSite) === normalizeId(selectedSite);




const Checkout = () => {
	const { user, hasPermission } = useAuth();
	const { cartItems, clearCart, maxCartLines: maxCartLinesFromContext } = useCart();
	const maxCartLines = Number(maxCartLinesFromContext) || 4000;
	const { optionKeys } = useOptions();
	const { items: complianceItems } = useCompliance();
	const { selectedSite, selectedSiteData, selectedSiteKey, siteData, selectedSiteCurrency, currencySymbol, selectedSiteLegalEnitity } = useSite();
	const { refreshNotifications } = useNotifications();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [selectedCustomer, setSelectedCustomer] = useState(null);
	const [buttonLoading, setButtonLoading] = useState(false);
	const [buttonSuccess, setButtonSuccess] = useState(false);
	const [cartProducts, setCartProducts] = useState([]);
	const summaryProducts = useMemo(() => {
		const grouped = new Map();
		(cartProducts || []).forEach((item) => {
			const product = item?.Product || {};
			const key = normalizeId(product?.product_id || product?.product_number || item?.ProductID);
			if (!key) return;
			const qty = Number(item?.Quantity || 0) || 0;
			const existing = grouped.get(key);
			if (existing) {
				existing.Quantity += qty;
			} else {
				grouped.set(key, {
					Product: product,
					Quantity: qty,
				});
			}
		});
		return Array.from(grouped.values());
	}, [cartProducts]);
	const [isInitialized, setIsInitialized] = useState(false);
	const [termsAccepted, setTermsAccepted] = useState(false);
	const [orderSchedule, setOrderSchedule] = useState(false);
	const [scheduleOpen, setScheduleOpen] = useState(false);
	const [selectedOrderSchedule, setSelectedOrderSchedule] = useState(null);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [dTOptions, setDTOptions] = useState([]);
	const [dMOptions, setDMOptions] = useState([]);
	const { t } = useTranslation();
	const DT_BY_LE = useMemo(() => buildDT_BY_LE(t), [t]);
	const DM_BY_LE = useMemo(() => buildDM_BY_LE(t), [t]);
	const canPlaceOrder = hasPermission("order_management.create_order")
	const orderSchedulesEnabled = optionKeys?.enableOrderSchedules !== "false";
	const canCreateOrderSchedule =
		orderSchedulesEnabled && hasPermission("order_management.create_order_schedules")
	const [expandedPanels, setExpandedPanels] = useState({
		panel1: true,
		panel2: true,
		panel3: true,
	});
	const [orderFailure, setOrderFaliure] = useState(false);
	const [orderFailureData, setOrderFaliureData] = useState(null);
	const [policyModal, setPolicyModal] = useState({ open: false, doc: null });
	const [eulaModalOpen, setEulaModalOpen] = useState(false);
	// Determine current legal entity (fallback to AUSA)
	const legalEntity = selectedSiteLegalEnitity || "AUSA";

	// Get available delivery terms & modes for this entity
	const deliveryTermsOptions = DT_BY_LE[legalEntity] || DT_BY_LE["AUSA"];
	const deliveryModeOptions = DM_BY_LE[legalEntity] || DM_BY_LE["AUSA"];
	const eulaDocs = complianceItems?.EULA || [];
	const privacyDoc = complianceItems?.PRIVACY || null;
	const termsDoc = complianceItems?.TERMS || null;

	// Define sensible defaults (first item of each list)
	const defaultDeliveryTerm = deliveryTermsOptions[0]?.term || "";
	const defaultModeOfDelivery = deliveryModeOptions[0]?.code || "";

	const [isEditing, setIsEditing] = useState({
		shipping: false,
		billing: false,
	});
	const canEditCheckoutAddresses = optionKeys?.enableCheckoutAddressEditing !== "false";

	// Saved site addresses
	const [shippingAddresses, setShippingAddresses] = useState([]);
	const [billingAddresses, setBillingAddresses] = useState([]);
	const [selectedShippingId, setSelectedShippingId] = useState(null);
	const [selectedBillingId, setSelectedBillingId] = useState(null);
	const [shippingDirty, setShippingDirty] = useState(false);
	const [billingDirty, setBillingDirty] = useState(false);

	// Rename modal for "Save as New Address" using ModalWrapper semantics
	const [renameOpen, setRenameOpen] = useState(false);
	const [renameSection, setRenameSection] = useState(null); // 'shipping' | 'billing'
	const [renameValue, setRenameValue] = useState("");

	const showSnack = (message, severity = "success") => {
		if (!message) return;
		toast.trigger({ message, severity });
	};

	const handlePolicyOpen = useCallback(
		(doc, fallbackUrl) => {
			openComplianceDocument({
				document: doc,
				fallbackUrl,
				onShowDescription: (document) =>
					setPolicyModal({ open: true, doc: document }),
			});
		},
		[]
	);

	const handleEulaView = useCallback(() => {
		if (!eulaDocs.length) {
			openComplianceDocument({
				document: null,
				fallbackUrl: "",
				onShowDescription: (document) =>
					setPolicyModal({ open: true, doc: document }),
			});
			return;
		}

		if (eulaDocs.length === 1) {
			openComplianceDocument({
				document: eulaDocs[0],
				fallbackUrl: "",
				onShowDescription: (document) =>
					setPolicyModal({ open: true, doc: document }),
			});
			return;
		}
		setEulaModalOpen(true);
	}, [eulaDocs]);

	const fetchSiteAddresses = async (type) => {
		if (!selectedSiteData?.site_id) return [];
		try {
			const resp = await getSiteAddressesNew(selectedSiteData.site_id, type);
			let list = resp?.data?.data ?? resp?.data ?? [];

			// Ensure defaults appear first
			list.sort((a, b) => (b.is_default ? 0 : 1) - (a.is_default ? 0 : 1));

			// If API didn't include defaults for any reason, synthesize on client
			const hasDefault = list.some(a => a.is_default);
			if (!hasDefault) {
				if (type === 'Shipping' && selectedSiteData) {
					list = [{
						id: 'default_shipping',
						is_default: true,
						address_type: 'Shipping',
						address_name: selectedSiteData.address_name_ln || 'Default Shipping',
						street1: selectedSiteData.street1_ln,
						street2: selectedSiteData.street2_ln,
						street3: selectedSiteData.street3_ln,
						city: selectedSiteData.city_ln,
						state: selectedSiteData.state_ln,
						zip: selectedSiteData.zip_ln,
						country: selectedSiteData.country_ln,
					}, ...list];
				}
				if (type === 'Billing' && selectedCustomer) {
					list = [{
						id: 'default_billing',
						is_default: true,
						address_type: 'Billing',
						address_name: selectedCustomer.address_name_cus || 'Default Billing',
						street1: selectedCustomer.street1_cus,
						street2: selectedCustomer.street2_cus,
						street3: selectedCustomer.street3_cus,
						city: selectedCustomer.city_cus,
						state: selectedCustomer.state_cus,
						zip: selectedCustomer.zip_cus,
						country: selectedCustomer.country_cus,
					}, ...list];
				}
			}

			// Add address_full key to each address object
			list = list.map(addr => {
				const {
					address_name,
					street1,
					street2,
					street3,
					city,
					state,
					zip,
					country
				} = addr;

				// Combine only non-null and non-empty values
				const parts = [address_name, street1, street2, street3, city, state, zip, country]
					.filter(Boolean)
					.join(', ');

				return { ...addr, address_full: parts };
			});

			return list;
		} catch (e) {
			return [];
		}
	};


	const [errors, setErrors] = useState({});
	const isMobile = useMediaQuery("(max-width:600px)");
	console.log("Option Keys: ", optionKeys)
	const [checkoutDetails, setCheckoutDetails] = useState({
		shipping_address: {
			name: "",
			street: "",
			city: "",
			zip: "",
			country: "",
			state: "",
		},
		billing_address: {
			name: "",
			street: "",
			city: "",
			zip: "",
			country: "",
			state: "",
		},
		additional_details: {
			delivery_terms: defaultDeliveryTerm,
			ship_complete: "true",
			mode_of_delivery: defaultModeOfDelivery,
			freight_number: "",
			order_notes: "",
		},
		payment_details: {
			payment_mode: "PO",
			payment_details: {
				po_number: " ",
				po_file: "",
			},
		},
		order_details: {
			products: [
				{
					product_id: "",
					ProductQty: "",
					ProductPrice: "",
					total: "",
				},
			],
			taxes: "",
			shipping: "",
			discounts: "",
			total: "",
			currency: selectedSiteCurrency || "usd",
		},
	});
	const shouldHideCarrierFields = ["PPD-ADD", "DDP", "DAP"].includes(
		checkoutDetails?.additional_details?.delivery_terms
	);

	const navigate = useNavigate();

	const VisuallyHiddenInput = styled("input")({
		clip: "rect(0 0 0 0)",
		clipPath: "inset(50%)",
		height: 1,
		overflow: "hidden",
		position: "absolute",
		bottom: 0,
		left: 0,
		whiteSpace: "nowrap",
		width: 1,
	});

	const formatAddress = (parts) => {
		return parts
			.map((part) => part?.trim())
			.filter(Boolean)
			.join(", ");
	};

	useEffect(() => {
		//always set DT/DM (so dropdown always has options)
		const legalEntity = selectedSiteLegalEnitity || "AUSA";
		const deliveryTermsOptions = DT_BY_LE[legalEntity] || DT_BY_LE["AUSA"];
		const deliveryModeOptions = DM_BY_LE[legalEntity] || DM_BY_LE["AUSA"];

		const translatedDeliveryTermsOptions = deliveryTermsOptions.map((opt) => ({
			...opt,
			//supports both descriptionKey and description (EUUK uses description)
			description: t(opt.descriptionKey || opt.description || ""),
		}));

		setDTOptions(translatedDeliveryTermsOptions);
		setDMOptions(deliveryModeOptions);

		// keep this logic for delivery_terms defaulting
		setCheckoutDetails((prev) => {
			const currentDeliveryTerm = prev?.additional_details?.delivery_terms || "";
			const isCurrentValidTerm = translatedDeliveryTermsOptions.some(
				(opt) => opt.term === currentDeliveryTerm
			);
			if (isCurrentValidTerm) return prev;

			const matchedByDescription = translatedDeliveryTermsOptions.find(
				(opt) => opt.description === currentDeliveryTerm
			);

			return {
				...prev,
				additional_details: {
					...prev.additional_details,
					delivery_terms:
						matchedByDescription?.term || translatedDeliveryTermsOptions[0]?.term || "",
				},
			};
		});

		//only block customer fetch if cus_id not ready
		if (!selectedSite || !selectedSiteData?.cus_id) return;

		const fetchCustomerData = async () => {
			try {
				const customer_resp = await getCustomerByIdForCusSites(selectedSiteData.cus_id);
				setSelectedCustomer(customer_resp.data);
				setCheckoutDetails((prev) => ({
					...prev,
					billing_address: {
						name: `${customer_resp.data.address_name_cus}`,
						street: formatAddress([
							customer_resp.data.street1_cus,
							customer_resp.data.street2_cus,
							customer_resp.data.street3_cus,
						]),
						city: `${customer_resp.data.city_cus}`,
						zip: `${customer_resp.data.zip_cus}`,
						country: `${customer_resp.data.country_cus}`,
						state: `${customer_resp.data.state_cus}`,
					},
					shipping_address: {
						name: `${selectedSiteData.address_name_ln} - ${selectedSiteData.customer_site_number}`,
						street: formatAddress([
							selectedSiteData.street1_ln,
							selectedSiteData.street2_ln,
							selectedSiteData.street3_ln,
						]),
						city: `${selectedSiteData.city_ln}`,
						zip: `${selectedSiteData.zip_ln}`,
						country: `${selectedSiteData.country_ln}`,
						state: `${selectedSiteData.state_ln}`,
					},
				}));
			} catch (error) {
				console.log(error);
			}
		};

		fetchCustomerData();
	}, [selectedSite, selectedSiteData, selectedSiteLegalEnitity, t]);
	const handleInputChange = (section, field, value) => {
		setCheckoutDetails((prev) => ({
			...prev,
			[section]: {
				...prev[section],
				[field]: value,
			},
		}));

		// Mark dirty if user typed while editing
		if (section === 'shipping_address' || section === 'shipping') setShippingDirty(true);
		if (section === 'billing_address' || section === 'billing') setBillingDirty(true);
	};

	const handleAccordionChange = (panel) => (event, isExpanded) => {
		setExpandedPanels((prev) => ({
			...prev,
			[panel]: isExpanded,
		}));
	};

	const handleCheckboxChange = (event) => {
		setTermsAccepted(event.target.checked);
	};

	useEffect(() => {
		if (!orderSchedulesEnabled && scheduleOpen) {
			setScheduleOpen(false);
		}
	}, [orderSchedulesEnabled, scheduleOpen]);

	const handleScheduleButton = async (event) => {
		// console.log("Order Schedule: ", transformCartProducts(cartProducts));
		// setSelectedOrderSchedule(transformCartProducts(cartProducts));
		setScheduleOpen(true);

	};


	const transformCartProducts = (products) => {
		const prods = products.map((item) => {
			const product = item.Product
			const price = product.product_sell_price || 0;

			return {
				id: null, // Keep as is
				order_id: product.product_id,
				product_id: product.product_id,
				machine_id: getCartMachineId(item),
				site_line_id: getCartSiteLineId(item),
				line_name: getCartLineName(item),
				line_number: getCartLineNumber(item),
				product_quantity: item.Quantity || 1,
				product_price: price.toString(),
				product_total: price.toString(),
				productsData: product
			};
		});
		const cart_products = cartProducts.map((item) => ({
			product_id: item.Product.product_id,
			product_name: item.Product.product_name,
			product_number: item.Product.product_number,
			machine_id: getCartMachineId(item),
			site_line_id: getCartSiteLineId(item),
			line_name: getCartLineName(item),
			line_number: getCartLineNumber(item),
			ProductQty: item.Quantity,
			ProductPrice: item.Product[`price_${selectedSiteCurrency}`],
			total: (item.Quantity * parseFloat(item.Product[`price_${selectedSiteCurrency}`])).toFixed(2),
		}));

		const productTotal = cart_products.reduce((total, item) => total + parseFloat(item.total), 0);
		const taxes = (productTotal * 0.08).toFixed(2);
		const discount = (productTotal * 0.05).toFixed(2);
		const shipping = 50.0;
		const total = (productTotal + parseFloat(taxes) - parseFloat(discount) + shipping).toFixed(2);
		return {
			shipping_address: checkoutDetails.shipping_address,
			billing_address: checkoutDetails.billing_address,
			additional_details: checkoutDetails.additional_details,
			payment_details: checkoutDetails.payment_details,
			order_details: {
				products: cart_products,
				taxes: taxes,
				shipping: shipping,
				discounts: discount,
				total: total,
			},
			selectedSite: selectedSiteData.site_id,
			loggedin_user: user.user_id,
			loggedin_user_email: user.user_email,
			loggedin_user_name: user.user_first_name + " " + user.user_last_name,
			loggedin_user_phone: user.user_phone || "",
			products: prods,
		}
	};

	const hasShippingError = Object.keys(errors).some((key) =>
		key.startsWith("shipping_address.")
	);

	const hasBillingError = Object.keys(errors).some((key) =>
		key.startsWith("billing_address.")
	);



	const handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const allowedTypes = [
			"application/pdf",
			"image/jpeg",
			"image/png",
			"application/msword",
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		];
		const maxFileSize = 10 * 1024 * 1024; // 10MB

		if (!allowedTypes.includes(file.type)) {
			Swal.fire({
				icon: "error",
				title: t("ALERT_MESSAGES.INVALID_FILE_TYPE_TITLE"),
				text: t("ALERT_MESSAGES.INVALID_FILE_TYPE_TEXT"),
			});
			return;
		}

		if (file.size > maxFileSize) {
			Swal.fire({
				icon: "error",
				title: t("ALERT_MESSAGES.FILE_TOO_LARGE_TITLE"),
				text: t("ALERT_MESSAGES.FILE_TOO_LARGE_TEXT"),
			});
			return;
		}

		// Store full file object
		setUploadedFile(file);

		// Reset input for future uploads
		event.target.value = null;
	};

	const handleDeleteFile = () => {
		setUploadedFile(null);
	};



	useEffect(() => {
		const fetchProducts = async () => {
			setLoading(true);
			setError(null);

			const selectedScopeKey = normalizeId(selectedSiteKey) ||
				((normalizeId(selectedSiteData?.site_id) && normalizeId(selectedSiteData?.cus_id))
					? `${normalizeId(selectedSiteData?.site_id)}:${normalizeId(selectedSiteData?.cus_id)}`
					: "");

			const filteredCartItems = cartItems.filter((item) =>
				selectedScopeKey
					? getScopeKey(item) === selectedScopeKey
					: sameAsSelectedSite(item?.Site, selectedSite)
			);

			if (filteredCartItems.length === 0) {
				setCartProducts([]);
				setLoading(false);
				setIsInitialized(true);
				return;
			}

			try {
				let products = [
					...new Set(
						filteredCartItems
							.filter((item) => normalizeId(getCartProductId(item)))
							.map((item) => Number(getCartProductId(item)))
							.filter((id) => Number.isInteger(id) && id > 0)
					),
				];
				let site_number = selectedSite;


				const response = await getProductsById(products, site_number);
				console.log("inside checkout getprodsbyid response", response);
				const productData = response?.data || [];

				const updatedCartItems = await Promise.all(
					filteredCartItems.map(async (item) => {
						const matchedProduct = productData.find(
							(product) => normalizeId(product?.product_id) === normalizeId(getCartProductId(item))
						);
						if (matchedProduct) {
							return {
								...item,
								Product: {
									...matchedProduct,
									machine_id: getCartMachineId(item) || matchedProduct.machine_id,
									site_line_id: getCartSiteLineId(item) || matchedProduct.site_line_id,
									line_name: getCartLineName(item) || matchedProduct.line_name || "",
									line_number: getCartLineNumber(item) || matchedProduct.line_number || "",
								},
							};
						}
						return null;
					})
				);

				setCartProducts(updatedCartItems.filter(item => item));
			} catch (err) {
				setError("Failed to fetch data: " + err.message);
			} finally {
				setLoading(false);
				setIsInitialized(true);
			}
		};

		if (cartItems.length > 0) {
			fetchProducts();
		} else {
			setCartProducts([]);
			setLoading(false);
			setIsInitialized(true);
		}
	}, [selectedSite, selectedSiteKey, selectedSiteData?.site_id, selectedSiteData?.cus_id, cartItems]);

	const validateAddress = (address, fieldPrefix) => {
		const newErrors = {};

		// This validation logic to find new errors remains the same
		if (!address.name?.trim()) newErrors[`${fieldPrefix}.name`] = t('UI_TEXT.NAME_REQUIRED');
		if (!address.street?.trim()) newErrors[`${fieldPrefix}.street`] = t('UI_TEXT.STREET_REQUIRED');
		if (!address.city?.trim()) newErrors[`${fieldPrefix}.city`] = t('UI_TEXT.CITY_REQUIRED');
		if (!address.zip?.trim()) newErrors[`${fieldPrefix}.zip`] = t('UI_TEXT.ZIPCODE_REQUIRED');
		if (!address.country?.trim()) newErrors[`${fieldPrefix}.country`] = t('UI_TEXT.COUNTRY_REQUIRED');
		if (!address.state?.trim()) newErrors[`${fieldPrefix}.state`] = t('UI_TEXT.STATE_REQUIRED');

		// Update state with errors
		setErrors((prevErrors) => {
			// 1. Create a new object that includes only the errors NOT related to the current section.
			const otherErrors = Object.fromEntries(
				Object.entries(prevErrors).filter(([key]) => !key.startsWith(fieldPrefix))
			);

			// 2. Return a new state object that combines the other errors with any new errors found for this section.
			return { ...otherErrors, ...newErrors };
		});

		// Return both the validation result and the errors found
		return {
			isValid: Object.keys(newErrors).length === 0,
			errors: newErrors
		};
	};

	const validateAdditionalOrderDetails = () => {
		const { delivery_terms, ship_complete, mode_of_delivery } = checkoutDetails.additional_details;
		const newErrors = {};
		const hideCarrierFields = ["PPD-ADD", "DDP", "DAP"].includes(delivery_terms);

		if (!delivery_terms) newErrors["additional_details.delivery_terms"] = "Delivery terms are required";
		if (!ship_complete) newErrors["additional_details.ship_complete"] = "Ship complete is required";
		if (!hideCarrierFields && !mode_of_delivery) newErrors["additional_details.mode_of_delivery"] = "Preferred carrier is required";

		// Return both the validation result and the errors found
		return {
			isValid: Object.keys(newErrors).length === 0,
			errors: newErrors
		};
	};

	const validatePaymentDetails = () => {
		return {
			isValid: true,
			errors: {},
		};
	};

	const handlePaymentModeChange = (event) => {
		const value = event.target.value;
		setCheckoutDetails((prev) => ({
			...prev,
			payment_details: {
				...prev.payment_details,
				payment_mode: value,
				payment_details: {
					...prev.payment_details.payment_details,
					po_number: value === "PO" ? prev.payment_details.payment_details.po_number : "",
				},
			},
		}));
	};

	const updateNestedField = (obj, path, value) => {
		if (path.length === 0) return value;
		const [key, ...rest] = path;

		return {
			...obj,
			[key]: rest.length > 0
				? updateNestedField(obj?.[key] ?? {}, rest, value)
				: value,
		};
	};



	const handleFieldChange = (section, field, value) => {
		setCheckoutDetails((prevDetails) => updateNestedField(prevDetails, [section, ...field.split(".")], value));
		if (section.includes('shipping')) setShippingDirty(true);
		if (section.includes('billing')) setBillingDirty(true);
	};

	const handleSelectSavedAddress = (section, addrId) => {
		const source = section === 'shipping' ? shippingAddresses : billingAddresses;
		const picked = source.find(a => a.id === addrId);
		if (!picked) return;
		const toUpdate = {
			name: picked.address_name,
			street: [picked.street1, picked.street2, picked.street3].filter(Boolean).join(', '),
			city: picked.city || '',
			state: picked.state || '',
			zip: picked.zip || '',
			country: picked.country || '',
		};
		setCheckoutDetails(prev => ({
			...prev,
			[section === 'shipping' ? 'shipping_address' : 'billing_address']: toUpdate,
		}));
		if (section === 'shipping') { setSelectedShippingId(addrId); setShippingDirty(false); }
		else { setSelectedBillingId(addrId); setBillingDirty(false); }
	};

	const splitStreet = (street) => {
		if (!street) return { street1: '', street2: '', street3: '' };
		const parts = street.split(',').map(s => s.trim()).filter(Boolean);
		return {
			street1: parts[0] || '',
			street2: parts[1] || '',
			street3: parts[2] || '',
		};
	};

	const handleSaveAddress = async (section, asNew = false, nameOverride) => {
		const addr = section === 'shipping' ? checkoutDetails.shipping_address : checkoutDetails.billing_address;
		const { street1, street2, street3 } = splitStreet(addr.street);
		const payload = {
			address_name: nameOverride || addr.name,
			address_type: section === 'shipping' ? 'Shipping' : 'Billing',
			site_id: selectedSiteData?.site_id,
			street1, street2, street3,
			city: addr.city,
			state: addr.state,
			zip: addr.zip,
			country: addr.country,
		};
		try {
			if (!asNew) {
				const id = section === 'shipping' ? selectedShippingId : selectedBillingId;
				if (id) {
					await updateSiteAddress(id, payload);
				} else {
					await createSiteAddress(payload);
				}
			} else {
				await createSiteAddress(payload);
			}
			// refresh lists
			if (section === 'shipping') {
				const list = await fetchSiteAddresses('Shipping');
				setShippingAddresses(list);
				setShippingDirty(false);
			} else {
				const list = await fetchSiteAddresses('Billing');
				setBillingAddresses(list);
				setBillingDirty(false);
			}
			showSnack(t('UI_TEXT.ADDRESS_SAVED'), 'success');
		} catch (e) {
			showSnack(t('ERRORS.FAILED_TO_SAVE_ADDRESS'), 'error');
		}
	};

	const handleOrderFailure = (orderData) => {
		navigate("/order-failure", { state: { orderData } });
	};

	const handleCheckout = async () => {
		setButtonLoading(true);

		// Parts can be collected without limit; the ceiling applies here, at submission. The
		// server enforces the same number, so this only saves a round trip and gives a clearer
		// message than a rejected request would.
		if (cartProducts.length > maxCartLines) {
			setButtonLoading(false);
			Swal.fire({
				icon: "warning",
				title: "Too many parts in this quote",
				text: `This quote has ${cartProducts.length.toLocaleString()} parts, which is over the ${maxCartLines.toLocaleString()} part limit. Please remove ${(cartProducts.length - maxCartLines).toLocaleString()} part(s) from your quote and try again.`,
				confirmButtonColor: "#1976d2",
			});
			return;
		}

		const selectedSiteDetails =
			selectedSiteData?.site_id
				? selectedSiteData
				: siteData.find((site) => site.customer_site_number === selectedSite);
		const selectedCusId = Number(selectedSiteDetails?.cus_id);
		const selectedSiteId = Number(selectedSiteDetails?.site_id);
		if (!Number.isFinite(selectedSiteId) || selectedSiteId <= 0 || !Number.isFinite(selectedCusId) || selectedCusId <= 0) {
			setButtonLoading(false);
			Swal.fire({
				icon: "error",
				title: t("ALERT_MESSAGES.ERROR"),
				text: t("UI_TEXT.INVALID_SITE_SELECTION", { defaultValue: "Invalid customer-site selection. Please reselect location and try again." }),
			});
			return;
		}

		let base64File = "";
		let fileName = "";
		if (uploadedFile) {
			try {
				const file = uploadedFile;
				fileName = file.name;
				const reader = new FileReader();
				base64File = await new Promise((resolve, reject) => {
					reader.onload = () => resolve(reader.result.split(",")[1]);
					reader.onerror = reject;
					reader.readAsDataURL(file);
				});
			} catch (error) {
				console.error("Error converting file to base64:", error);
				setButtonLoading(false);
				Swal.fire({
					icon: "error",
					title: t('ALERT_MESSAGES.ERROR'),
					text: t('UI_TEXT.ERROR_PROCESSING_UPLOADED_FILE_PLEASE_TRY_AGAIN'),
				});
				return;
			}
		}

		const isShippingValid = validateAddress(checkoutDetails.shipping_address, "shipping_address");
		const isBillingValid = validateAddress(checkoutDetails.billing_address, "billing_address");
		const areAdditionalDetailsValid = validateAdditionalOrderDetails();
		const arePaymentDetailsValid = validatePaymentDetails();

		// Combine all errors before updating state
		const allErrors = {
			...isShippingValid.errors,
			...isBillingValid.errors,
			...areAdditionalDetailsValid.errors,
			...arePaymentDetailsValid.errors
		};

		if (
			!isShippingValid.isValid ||
			!isBillingValid.isValid ||
			!areAdditionalDetailsValid.isValid ||
			!arePaymentDetailsValid.isValid ||
			!termsAccepted
		) {
			setButtonLoading(false);

			// Update errors state with all collected errors
			setErrors(allErrors);

			// Collect all missing fields from the collected errors
			const missingFields = [];

			Object.keys(allErrors).forEach((key) => {
				if (key.startsWith("shipping_address.")) {
					const fieldName = key.split(".")[1]?.replace("_", " ");
					missingFields.push(`<b>Shipping Address</b> → ${fieldName}`);
				} else if (key.startsWith("billing_address.")) {
					const fieldName = key.split(".")[1]?.replace("_", " ");
					missingFields.push(`</b>Billing Address</b> → ${fieldName}`);
				} else if (key.startsWith("additional_details.")) {
					const fieldName = key.split(".")[1]?.replace("_", " ");
					missingFields.push(`</b>Additional Details</b> → ${fieldName}`);
				} else if (key.startsWith("payment_details.")) {
					const fieldName = key.split(".").slice(-1)[0]?.replace("_", " ");
					missingFields.push(`</b>Payment Details</b> → ${fieldName}`);
				}
			});

			if (!termsAccepted) {
				missingFields.push(`</b>${t('UI_TEXT.TERMS_CONDITIONS')}</b> → ${t('UI_TEXT.NOT_ACCEPTED')}`);
			}

			const formattedList = missingFields.length
				? `<ul style="list-style-type:none; padding:0; margin:10px 0; font-size:12px; text-align:center;">
						${missingFields.map((f) => `<li>${f}</li>`).join("")}
					</ul>`
				: `<p style="font-size:12px; text-align:center;">Please fill in all required fields before proceeding.</p>`;

			Swal.fire({
				icon: "error",
				title: t('UI_TEXT.MISSING_REQUIRED_FIELDS'),
				html: `
					<div style="font-size:12px; text-align:center;">
						${t('UI_TEXT.SOME_REQUIRED_FIELDS_ARE_MISSING_OR_INCOMPLETE')}
					</div>
					${formattedList}
					`,
				confirmButtonText: t('UI_TEXT.REVIEW_AND_FIX'),
				confirmButtonColor: "#1976d2",
			});

			return;
		}



		const cart_products = cartProducts.map((item) => ({
			product_id: item.Product.product_id,
			product_name: item.Product.product_name,
			product_number: item.Product.product_number,
			machine_id: getCartMachineId(item),
			site_line_id: getCartSiteLineId(item),
			line_name: getCartLineName(item),
			line_number: getCartLineNumber(item),
			ProductQty: item.Quantity,
			ProductPrice: item.Product[`price_${selectedSiteCurrency}`],
			total: (item.Quantity * parseFloat(item.Product[`price_${selectedSiteCurrency}`])).toFixed(2),
		}));

		const productTotal = cart_products.reduce((total, item) => total + parseFloat(item.total), 0);
		const taxes = (productTotal * 0.08).toFixed(2);
		const discount = (productTotal * 0.05).toFixed(2);
		const shipping = 50.0;
		const total = (productTotal + parseFloat(taxes) - parseFloat(discount) + shipping).toFixed(2);

		const newCheckoutDetails = {
			shipping_address: checkoutDetails.shipping_address,
			billing_address: checkoutDetails.billing_address,
			additional_details: checkoutDetails.additional_details,
			payment_details: {
				payment_mode: checkoutDetails.payment_details.payment_mode,
				payment_details: {
					po_number: checkoutDetails.payment_details.payment_details.po_number,
					po_file: base64File,
					po_filename: fileName,
				},
			},
			order_details: {
				products: cart_products,
				taxes: taxes,
				shipping: shipping,
				discounts: discount,
				total: total,
				currency: selectedSiteCurrency || "usd"
			},
			selectedSite: selectedSiteId,
			cus_id: selectedCusId,
			loggedin_user: user.user_id,
			loggedin_user_email: user.user_email,
			loggedin_user_name: user.user_first_name + " " + user.user_last_name,
			loggedin_user_phone: user.user_phone || "",
		};

		// Identifies this specific placement attempt. The server stores it, so a retry can never
		// create a second order, and after a timeout we can ask whether this attempt succeeded.
		const clientRequestId =
			(typeof crypto !== "undefined" && crypto.randomUUID)
				? crypto.randomUUID()
				: `cro-${Date.now()}-${Math.random().toString(16).slice(2)}`;
		newCheckoutDetails.client_request_id = clientRequestId;

		setCheckoutDetails(newCheckoutDetails);
		console.log("Order Data: ", newCheckoutDetails);
		try {
			// Send the API request to place the order
			const response = await createOrder(newCheckoutDetails);
			console.log("inside checkout createorder response", response);
			// Handle success
			if (response.data && response.status) {
				trackEvent("rfq_created", {
					step: "rfq_created",
					action_category: "checkout",
					element_label: "Create RFQ",
					path: `/order-received/${response.data.order_key}`,
					order_key: response.data.order_key || "",
					order_total: total,
					currency: selectedSiteCurrency || "usd",
					product_count: cart_products.length,
					customer_id: selectedCusId,
					site_id: selectedSiteId,
				});
				clearCart();
				setButtonLoading(false);
				setButtonSuccess(true);
				try {
					await refreshNotifications(500, 0);
					setTimeout(() => {
						refreshNotifications(500, 0);
					}, 600);
				} catch {
					// badge refresh is best-effort
				}
				setTimeout(() => {
					setButtonSuccess(false);
					navigate(`/order-received/${response.data.order_key}`);
				}, 1000);
			} else {
				setButtonLoading(false);
				console.error("Failed to place order: ", response.data.message);
				handleOrderFailure(newCheckoutDetails)
				setError(response.data.message || t('ALERT_MESSAGES.ERROR_OCCURED_WHILE_PLACING'));
			}
		} catch (error) {
			console.error("Error while placing the order", error);
			// The request failed client-side (timeout, dropped connection). That does NOT mean the
			// order failed -- the server may have created it. Ask before reporting a failure, so a
			// succeeded order is never shown to the user as failed.
			const confirmed = await confirmOrderAfterFailure(clientRequestId);
			if (confirmed) return;
			setButtonLoading(false);
			handleOrderFailure(newCheckoutDetails)
			setError(t('ALERT_MESSAGES.ERROR_OCCURED_PLACING_ORDER'));
		}
	};

	// Polls the server to find out whether the order for this attempt actually exists.
	// Returns true (and routes to the confirmation page) if it does.
	const confirmOrderAfterFailure = async (clientRequestId) => {
		if (!clientRequestId) return false;
		const delays = [1000, 2000, 4000, 6000, 8000];
		for (const wait of delays) {
			await new Promise((resolve) => setTimeout(resolve, wait));
			try {
				const probe = await getOrderStatusByRequestId(clientRequestId);
				if (probe?.status && probe?.data?.found) {
					clearCart();
					setButtonLoading(false);
					setButtonSuccess(true);
					setTimeout(() => {
						setButtonSuccess(false);
						navigate(`/order-received/${probe.data.order_key}`);
					}, 1000);
					return true;
				}
			} catch {
				// keep probing; a failed probe tells us nothing either way
			}
		}
		return false;
	};

	const toggleEdit = (section) => {
		if (!canEditCheckoutAddresses) return;
		setIsEditing((prev) => ({ ...prev, [section]: !prev[section] }));
		// On enabling edit, fetch saved addresses
		(async () => {
			if (!isEditing[section]) {
				if (section === 'shipping') {
					const list = await fetchSiteAddresses('Shipping');
					setShippingAddresses(list);
					const def = list.find(a => a.is_default);
					if (def) {
						setSelectedShippingId(def.id);
						handleSelectSavedAddress('shipping', def.id);
					}
				} else {
					const list = await fetchSiteAddresses('Billing');
					setBillingAddresses(list);
					const def = list.find(a => a.is_default);
					if (def) {
						setSelectedBillingId(def.id);
						handleSelectSavedAddress('billing', def.id);
					}
				}
			}
		})();
	};

	useEffect(() => {
		if (canEditCheckoutAddresses) return;
		setIsEditing({ shipping: false, billing: false });
		setRenameOpen(false);
	}, [canEditCheckoutAddresses]);

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	if (error && !loading && !orderFailure) {
		return (
			<Alert severity="error" className="error-alert">
				{error}
			</Alert>
		);
	}

	if (orderFailure && error) {
		return (
			<>
				{orderFailureData ? (<>
					<OrderFailure orderData={orderFailureData} />
				</>) : (
					<Alert severity="error" className="error-alert">
						{error}
					</Alert>
				)}
			</>
		)
	}

	if (!hasPermission("order_management.create_order")) {
		return <NotAuthorized />
	}

	return (
		<Box padding={2} pt={"5px"} width="100vw">
			{/* Rename modal for save-as-new */}
			<ModalWrapper
				open={renameOpen}
				setOpen={setRenameOpen}
				title={'Save as New Address'}
				content={(
					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 1 }}>
						<TextField size="small" label={t('UI_TEXT.ADDRESS_NAME')} value={renameValue} onChange={(e) => setRenameValue(e.target.value)} />
					</Box>
				)}
				actions={(
					<>
						<Button variant="outlined" onClick={() => setRenameOpen(false)}>{t('BUTTON.CANCEL')}</Button>
						<Button variant="contained" onClick={() => { if (renameValue?.trim()) { handleSaveAddress(renameSection, true, renameValue.trim()); setRenameOpen(false); } }}>Save</Button>
					</>
				)}
			/>

			<PageTitle title={t('BUTTON.CHECKOUT')}></PageTitle>
			<Box
				display="flex"
				justifyContent="space-between"
				gap="20px"
				alignItems="flex-start"
				flexDirection={isMobile ? "column" : "row"}
				margin="0 auto"
				marginTop={3}
				sx={{ width: isMobile ? "100%" : "85%" }}>
				{/* Left Section */}
				<Box width={isMobile ? "100%" : "65%"} padding="5px" marginBottom={2} sx={{ boxShadow: "0 0 6px 1px rgba(0,0,0,0.1)", borderRadius: '10px' }}>
					<Accordion sx={{ boxShadow: "none" }} onChange={handleAccordionChange("panel1")} defaultExpanded data-tour="checkout-shipping-billing">
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold" }}
								color={expandedPanels.panel1 ? "primary" : ""}>
								{t('UI_TEXT.SHIPPING_BILLING_ADDRESS')}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Box
								display="flex"
								flexDirection={isMobile ? "column" : "row"}
								justifyContent="space-between"
								gap="10px">
								{/* Shipping Address Card */}
								<Box
									sx={{
										width: isMobile ? "100%" : "48%",
										borderRadius: "10px",
										...(hasShippingError
											? {
												borderColor: "error.main",
												borderWidth: 1,
												borderStyle: "solid",
											}
											: {
												borderColor: "#e5e7eb",
												borderWidth: 1,
												borderStyle: "solid",
											}),
										p: 2, // same padding as CardContent
									}}
								>
									<Box display="flex" justifyContent="space-between" alignItems="center">
										<Typography variant="h6" sx={{ fontWeight: "bold" }}>
											{t('UI_TEXT.SHIPPING_ADDRESS')}
										</Typography>
										{canEditCheckoutAddresses && (
											<IconButton
												onClick={() => toggleEdit("shipping")}
												color={isEditing.shipping ? "primary" : ""}>
												{isEditing.shipping ?
													<Tooltip title={t("UI_TEXT.TOOLTIP_SAVE_ADDRESS")} arrow placement="top">
														<Check />
													</Tooltip>
													:
													<Tooltip title={t("UI_TEXT.TOOLTIP_EDIT_ADDRESS")} arrow placement="top">
														<EditIcon />
													</Tooltip>
												}
											</IconButton>
										)}
									</Box>
									{canEditCheckoutAddresses && isEditing.shipping ? (
										<Box mt={2}>

											<Autocomplete
												fullWidth
												size="small"
												options={shippingAddresses}
												getOptionLabel={(option) => option.address_name || ''}
												value={shippingAddresses.find((addr) => addr.id === selectedShippingId) || null}
												onChange={(event, newValue) => handleSelectSavedAddress('shipping', newValue ? newValue.id : '')}
												renderInput={(params) => (
													<TextField {...params} label="Select Saved Address" variant="outlined" />
												)}
												renderOption={(props, option) => (
													<li {...props} key={option.id}>
														<Box>
															<Typography variant="body1">{option.address_name}</Typography>
															<Typography
																variant="body2"
																color="text.secondary"
																fontStyle="italic"
																fontSize="11px"
															>
																<b>{t('LABELS.ADDRESS')}: </b>{option.address_full}
															</Typography>
														</Box>
													</li>
												)}
											/>
											<Divider sx={{ my: 2 }} />
											<TextField
												required
												label={t('LABELS.NAME')}
												size="small"
												fullWidth
												value={checkoutDetails.shipping_address.name}
												error={!!errors["shipping_address.name"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "name", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.STREET')}
												required
												size="small"
												fullWidth
												value={checkoutDetails.shipping_address.street}
												error={!!errors["shipping_address.street"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "street", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.CITY')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.shipping_address.city}
												error={!!errors["shipping_address.city"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "city", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.STATE')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.shipping_address.state}
												error={!!errors["shipping_address.state"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "state", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.ZIP')}
												size="small"
												required
												fullWidth
												value={checkoutDetails.shipping_address.zip}
												error={!!errors["shipping_address.zip"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "zip", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.COUNTRY')}
												size="small"
												required
												fullWidth
												value={checkoutDetails.shipping_address.country}
												error={!!errors["shipping_address.country"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "country", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<Box display="flex" gap={1} justifyContent="flex-end" mt={1}>
												{shippingDirty && (
													(() => {
														const selected = shippingAddresses.find(a => a.id === selectedShippingId);
														const isDefault = !!selected?.is_default;
														return (
															<>
																{!isDefault && (
																	<Button size="small" variant="outlined" onClick={() => handleSaveAddress('shipping', false)}>Save Address</Button>
																)}
																<Button size="small" variant="contained" onClick={() => { setRenameSection('shipping'); setRenameValue(checkoutDetails.shipping_address.name || ''); setRenameOpen(true); }}>
																	Save as New Address
																</Button>
															</>
														);
													})()
												)}
											</Box>
										</Box>
									) : (
										<Box>
											<Typography
												variant="body1"
												color={errors["shipping_address.name"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.name?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.street"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.street?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.city"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.city?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.state"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.state?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.zip"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.zip?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.country"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.country?.trim() || "—"}
											</Typography>
										</Box>
									)}

								</Box>

								{/* Billing Address Card */}
								<Box
									sx={{
										width: isMobile ? "100%" : "48%",
										borderRadius: "10px",
										...(hasBillingError
											? {
												borderColor: "error.main",
												borderWidth: 1,
												borderStyle: "solid",
											}
											: {
												borderColor: "#e5e7eb",
												borderWidth: 1,
												borderStyle: "solid",
											}),
										p: 2, // same padding as CardContent
									}}
								>
									<Box display="flex" justifyContent="space-between" alignItems="center">
										<Typography variant="h6" sx={{ fontWeight: "bold" }}>
											{t('UI_TEXT.BILLING_ADDRESS')}
										</Typography>
										{canEditCheckoutAddresses && (
											<IconButton
												onClick={() => toggleEdit("billing")}
												color={isEditing.billing ? "primary" : ""}>
												{isEditing.billing ?
													<Tooltip title={t("UI_TEXT.TOOLTIP_SAVE_ADDRESS")} arrow placement="top">
														<Check />
													</Tooltip>
													:
													<Tooltip title={t("UI_TEXT.TOOLTIP_EDIT_ADDRESS")} arrow placement="top">
														<EditIcon />
													</Tooltip>
												}
											</IconButton>
										)}
									</Box>
									{canEditCheckoutAddresses && isEditing.billing ? (
										<Box mt={2}>
											<Autocomplete
												fullWidth
												size="small"
												options={billingAddresses}
												getOptionLabel={(option) => option.address_name || ''}
												value={billingAddresses.find((addr) => addr.id === selectedBillingId) || null}
												onChange={(event, newValue) => handleSelectSavedAddress('billing', newValue ? newValue.id : '')}
												renderInput={(params) => (
													<TextField {...params} label="Select Saved Address" variant="outlined" />
												)}
												renderOption={(props, option) => (
													<li {...props} key={option.id}>
														<Box>
															<Typography variant="body1">{option.address_name}</Typography>
															<Typography
																variant="body2"
																color="text.secondary"
																fontStyle="italic"
																fontSize="11px"
															>
																<b>{t('LABELS.ADDRESS')}: </b>{option.address_full}
															</Typography>
														</Box>
													</li>
												)}
											/>

											<Divider sx={{ my: 2 }} />
											<TextField
												label={t('LABELS.NAME')}
												size="small"
												required
												fullWidth
												value={checkoutDetails.billing_address.name}
												error={!!errors["billing_address.name"]}
												onChange={(e) =>
													handleInputChange("billing_address", "name", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.STREET')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.street}
												error={!!errors["billing_address.street"]}
												onChange={(e) =>
													handleInputChange("billing_address", "street", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.CITY')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.city}
												error={!!errors["billing_address.city"]}
												onChange={(e) =>
													handleInputChange("billing_address", "city", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.STATE')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.state}
												error={!!errors["billing_address.state"]}
												onChange={(e) =>
													handleInputChange("billing_address", "state", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.ZIP')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.zip}
												error={!!errors["billing_address.zip"]}
												onChange={(e) =>
													handleInputChange("billing_address", "zip", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.COUNTRY')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.country}
												error={!!errors["billing_address.country"]}
												onChange={(e) =>
													handleInputChange("billing_address", "country", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<Box display="flex" gap={1} justifyContent="flex-end" mt={1}>
												{billingDirty && (
													(() => {
														const selected = billingAddresses.find(a => a.id === selectedBillingId);
														const isDefault = !!selected?.is_default;
														return (
															<>
																{!isDefault && (
																	<Button size="small" variant="outlined" onClick={() => handleSaveAddress('billing', false)}>Save Address</Button>
																)}
																<Button size="small" variant="contained" onClick={() => { setRenameSection('billing'); setRenameValue(checkoutDetails.billing_address.name || ''); setRenameOpen(true); }}>
																	Save as New Address
																</Button>
															</>
														);
													})()
												)}
											</Box>
										</Box>
									) : (
										<Box>
											<Typography
												variant="body1"
												color={errors["billing_address.name"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.name?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.street"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.street?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.city"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.city?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.state"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.state?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.zip"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.zip?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.country"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.country?.trim() || "—"}
											</Typography>
										</Box>
									)}

								</Box>
							</Box>
						</AccordionDetails>
					</Accordion>

					<Accordion sx={{ boxShadow: "none" }} onChange={handleAccordionChange("panel2")} defaultExpanded data-tour="checkout-additional-details">
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold" }}
								color={expandedPanels.panel2 ? "primary" : ""}>
								{t('UI_TEXT.ADDITIONAL_ORDER_DETAILS')}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
								<Box sx={{ display: "flex", gap: 2 }}>
									<FormControl fullWidth required>
										<InputLabel>{t('UI_TEXT.DELIVERY_TERMS')}</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.additional_details.delivery_terms}
											error={!!errors["additional_details.delivery_terms"]}
											label={t('UI_TEXT.DELIVERY_TERMS')}
											onChange={(e) =>
												handleFieldChange("additional_details", "delivery_terms", e.target.value)
											}
										>
											{dTOptions.map((opt) => (
												<MenuItem key={opt.term} value={opt.term}>
													{opt.description}
												</MenuItem>
											))}
										</Select>
									</FormControl>

									<FormControl fullWidth required>
										<InputLabel>{t('UI_TEXT.SHIP_COMPLETE')}</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.additional_details.ship_complete}
											error={!!errors["additional_details.ship_complete"]}
											label={t('UI_TEXT.SHIP_COMPLETE')}
											onChange={(e) =>
												handleFieldChange("additional_details", "ship_complete", e.target.value)
											}>
											<MenuItem value="true">{t('MENU_ITEMS.YES')}</MenuItem>
											<MenuItem value="false">{t('MENU_ITEMS.NO')}</MenuItem>
										</Select>
									</FormControl>
								</Box>

								{!shouldHideCarrierFields && (
									<Box sx={{ display: "flex", gap: 2 }}>
										<FormControl fullWidth required>
											<InputLabel>{t("LABELS.PREFERRED_CARRIER", { defaultValue: "Preferred Carrier" })}</InputLabel>
											<Select
												size="small"
												value={checkoutDetails.additional_details.mode_of_delivery}
												error={!!errors["additional_details.mode_of_delivery"]}
												label={t("LABELS.PREFERRED_CARRIER", { defaultValue: "Preferred Carrier" })}
												onChange={(e) =>
													handleFieldChange("additional_details", "mode_of_delivery", e.target.value)
												}
											>
												{dMOptions.map((opt) => (
													<MenuItem key={opt.code} value={opt.code}>
														{opt.description}
													</MenuItem>
												))}
											</Select>
										</FormControl>

										<TextField
											fullWidth
											size="small"
											label={t("LABELS.YOUR_CARRIER_NUMBER", { defaultValue: "Your Carrier #" })}
											value={checkoutDetails.additional_details.freight_number}
											onChange={(e) =>
												handleFieldChange("additional_details", "freight_number", e.target.value)
											}
											placeholder={t("PLACEHOLDER.ENTER_CARRIER_NUMBER", { defaultValue: "Enter carrier number" })}
										/>
									</Box>
								)}

								<TextField
									fullWidth
									size="small"
									label={t('UI_TEXT.ORDER_NOTES')}
									multiline
									rows={4}
									value={checkoutDetails.additional_details.order_notes}
									onChange={(e) =>
										handleFieldChange("additional_details", "order_notes", e.target.value)
									}
									placeholder={t('PLACEHOLDER.ENTER_ORDER_NOTES')}
								/>
							</Box>
						</AccordionDetails>
					</Accordion>

				</Box>

				{/* Order Summary */}
				<Box width={isMobile ? "100%" : "35%"} sx={{ position: "sticky", top: DEFAULT_LAYOUT === "layout2" ? "150px" : "100px" }}>
					<Card sx={{ boxShadow: "0 0 6px 1px rgba(0,0,0,0.1)", borderRadius: '10px' }} data-tour="checkout-order-summary">
						<CardContent>
							<Box display="flex" alignItems="center" justifyContent="space-between" mb={1} flexWrap={"wrap"}>
								<Typography variant="h6" fontWeight="bold">
									{t('UI_TEXT.ORDER_SUMMARY')}
								</Typography>

							</Box>
							<Box display="flex" alignItems="center" justifyContent="flex-end" columnGap={1} my={1}>
								{/* {canCreateOrderSchedule && <Button
									color="primary"
									size="small"
									variant="outlined"
									startIcon={<ScheduleOutlined />}
									onClick={handleScheduleButton}
								>
									{t('BUTTON.CREATE_ORDER_SCHEDULE')}
								</Button>} */}
								<Button size="small" variant="outlined" startIcon={<DownloadIcon />} onClick={() => {
									try {
										const rows = summaryProducts.map(p => ({
											product_name: p.Product.product_name,
											product_number: p.Product.product_number,
											quantity: p.Quantity,
											price: p.Product[`price_${selectedSiteCurrency}`],
											line_total: (Number(p.Quantity) * Number(p.Product[`price_${selectedSiteCurrency}`] || 0)).toFixed(2)
										}));
										const headers = ['Product Name', 'Product Number', 'Quantity', 'Price', 'Line Total'];
										const csv = [headers.join(','), ...rows.map(r => [r.product_name, r.product_number, r.quantity, r.price, r.line_total].map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))].join('\n');
										const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
										const url = URL.createObjectURL(blob);
										const a = document.createElement('a');
										a.href = url;
										const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
										a.download = `quote-summary-${ts}.csv`;
										document.body.appendChild(a);
										a.click();
										document.body.removeChild(a);
										URL.revokeObjectURL(url);
									} catch (e) {
										Swal.fire({ icon: 'error', title: 'Export failed', text: 'Could not export quote summary.' });
									}
								}}>
									Export
								</Button>

							</Box>
							<Box sx={{ maxHeight: 200, overflowY: "auto" }}>
								<TableContainer>
									<Table>
										<TableHead>
											<TableRow>
												<TableCell>{t('TABLE_HEADERS.PART')}</TableCell>
												<TableCell align="center">{t('UI_TEXT.QTY')}</TableCell>
												{/* <TableCell align="right">{t('TABLE_HEADERS.PRICE')}</TableCell> */}
											</TableRow>
										</TableHead>
										<TableBody>
											{/* Dynamically render products */}
											{summaryProducts.map((product, index) => (
												<TableRow style={{ fontSize: '11px' }} key={index}>
													<TableCell style={{ fontSize: '11px' }}>{product.Product.product_name}</TableCell>
													<TableCell align="center" style={{ fontSize: '11px' }}>x {product.Quantity}</TableCell>
													<TableCell align="right" style={{ fontSize: '11px' }}>
														{/* {currencySymbol}
														{product.Product[`price_${selectedSiteCurrency}`]}
														*/}
													</TableCell>
												</TableRow>
											))}

											{/* Total Row */}
											<TableRow>
												<TableCell />
												<TableCell colSpan={1} align="center" style={{ fontSize: '12px', fontWeight: 'bold' }}>
													{/* {t('TABLE_HEADERS.TOTAL')} */}
												</TableCell>
												<TableCell align="right" style={{ fontSize: '12px', fontWeight: 'bold' }}>
													{/* {currencySymbol}
													{cartProducts
														.reduce(
															(total, product) =>
																total +
																parseFloat(
																	product.Product[`price_${selectedSiteCurrency}`]
																).toFixed(2) *
																product.Quantity,
															0
														)
														.toFixed(2)}
													*/}
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Box>
							<Box px={1} my={1}>

								{/* <Typography my={2} variant="body2" fontSize={"11px"} color="text.secondary" marginTop="25px">
									Shipping & Taxes will be added to Final Invoice
								</Typography> */}

								<FormControlLabel
									control={
										<Checkbox required color="primary" checked={termsAccepted} onChange={handleCheckboxChange} />
									}
									label={
										<>
											{t('LABELS.ACCEPT')}{" "}
											<Link
												component="button"
												type="button"
												onClick={(e) => {
													e.preventDefault();
													handlePolicyOpen(termsDoc, "");
												}}
												color="primary"
												sx={{ cursor: "pointer" }}
											>
												{t('TITLES.TERMS_AND_CONDITIONS')}
											</Link>
										</>
									}
								/>
								{/* <Typography variant="body2" mt={1}>
									{t('UI_TEXT.VIEW_EULA_LIBRARY') || "Need to review the active EULAs?"}{" "}
									<Link
										component="button"
										type="button"
										onClick={(e) => {
											e.preventDefault();
											handleEulaView();
										}}
										color="primary"
										sx={{ cursor: "pointer" }}
									>
										{t('LABELS.EULA')}
									</Link>
								</Typography> */}
							</Box>



							{/* Place Order Button */}
							<Button
								variant="contained"
								color="primary"
								fullWidth
								disabled={!termsAccepted || !canPlaceOrder}
								onClick={handleCheckout}>
								{buttonLoading ? (
									<>{t('BUTTON.PLACING_ORDER')}</>
								) : buttonSuccess ? (
									<>
										<CheckCircleIcon sx={{ color: "white", marginRight: 1 }} />
										{t('BUTTON.PLACED')}
									</>
								) : (
									t('BUTTON.PLACED_ORDER')
								)}
							</Button>

							{!canPlaceOrder && (
								<Typography variant="body1" color="error" sx={{ mt: 1 }}>
									{t('UI_TEXT.YOU_ARE_NOT_AUTHORIZED_ORDER')} <br />
									{t('UI_TEXT.PLEASE_CONTACT_THE_CUTOMER_CARE_FOR_FURTHER_DETAILS')}
								</Typography>
							)}

							<Typography variant="body1" sx={{ fontSize: "11px", marginTop: "10px" }}>
								{t('UI_TEXT.PLEASE_CONTACT_THE_CUTOMER_CARE_FOR_FURTHER_DETAILS')}
							</Typography>
						</CardContent>
					</Card>
				</Box>
				{scheduleOpen && canCreateOrderSchedule && <ScheduleOrder
					open={scheduleOpen}
					setOpen={setScheduleOpen}
					selectedOrder={transformCartProducts(cartProducts)}
				/>}
				<ComplianceDescriptionModal
					open={policyModal.open}
					setOpen={(open) =>
						setPolicyModal((prev) => ({ open, doc: open ? prev.doc : null }))
					}
					document={policyModal.doc}
				/>
				<EulaLibraryModal
					open={eulaModalOpen}
					setOpen={setEulaModalOpen}
					documents={eulaDocs}
				/>
			</Box>
			{(buttonLoading || buttonSuccess) && <DefaultLoader />}
		</Box>
	);
};

export default Checkout;
